const GIFT_VARIANT = 43579921367107; // M Size

$(document).ajaxSuccess(function (event, xhr, settings) {

    if (!settings.url.includes('/cart/add.js')) return;

    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {

        let eligible = false;
        let giftExists = false;

        cart.items.forEach(item => {

            if (item.variant_id == GIFT_VARIANT) {
                giftExists = true;
            }

            if (item.final_line_price >= 79900 && item.variant_id != GIFT_VARIANT) {
                eligible = true;
            }

        });

        if (eligible && !giftExists) {

            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type':'application/json'
                },
                body: JSON.stringify({
                    id: GIFT_VARIANT,
                    quantity:1
                })
            }).then(()=>{
                location.reload();
            });

        }

      });

});